// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__VaP1a","requiredAsterisk":"Info_requiredAsterisk__8Oi_R"};